var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundMotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 250,
    viewBox: "0 0 1000 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M885.645 163.819C885.645 160.504 886.962 157.324 889.306 154.98C891.65 152.636 894.83 151.319 898.145 151.319H1000V98.681H898.145C894.83 98.681 891.65 97.364 889.306 95.0198C886.962 92.6756 885.645 89.4962 885.645 86.181C885.645 82.8658 886.962 79.6864 889.306 77.3422C891.65 74.998 894.83 73.681 898.145 73.681H1000V0H859.406C843.294 16.111 829.325 30.081 809.406 50H584.406L534.406 0H0V250H534.405L584.405 200H809.405C829.324 219.919 843.293 233.889 859.405 250H1000V176.319H898.145C894.83 176.319 891.65 175.002 889.306 172.658C886.962 170.314 885.645 167.134 885.645 163.819Z",
    fill: "#5D568C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMotif);
export default __webpack_public_path__ + "static/media/BackgroundMotif.49457af54c9e7296e26b39c7b89e1ae4.svg";
export { ForwardRef as ReactComponent };